import { Capacitor } from '@capacitor/core';

/**
 * Где мы сейчас работаем — в браузере или внутри приложения из стора.
 *
 * ЗАЧЕМ. В приложении из App Store нельзя вести человека к оплате мимо Apple:
 * они требуют продавать доступ к платному содержимому своими встроенными
 * покупками и берут за это 15–30%. Отказ по правилу 3.1.1 — одна из самых
 * частых причин, по которым приложение разворачивают. Причём отказывают не
 * только за кнопку «Оплатить», но и за ТЕКСТ, который зовёт покупать снаружи.
 *
 * ПОЧЕМУ ПРОВЕРКА ВО ВРЕМЯ РАБОТЫ, А НЕ ОТДЕЛЬНАЯ СБОРКА. Сайт и приложение
 * собираются из одного и того же кода: `dist/` уезжает и на сервер, и внутрь
 * приложения. Если бы разница задавалась флагом сборки, однажды на сайт уехала
 * бы сборка без тарифов, а в стор — с тарифами. Одна сборка, ведущая себя
 * по-разному, такой ошибки не допускает в принципе.
 *
 * В браузере `isNativePlatform()` всегда false, поэтому на сайте всё остаётся
 * как было: и тарифы, и оплата.
 */
export function isStoreBuild(): boolean {
  try {
    return Capacitor.isNativePlatform();
  } catch {
    // На всякий случай: если библиотека почему-то недоступна, считаем, что мы
    // в браузере. Ошибиться в эту сторону безопаснее — на сайте оплата нужна.
    return false;
  }
}

/**
 * Живое видео и Speaking Rooms теперь управляются НАСТРОЙКОЙ С СЕРВЕРА, а не
 * константой в этом файле.
 *
 * ПОЧЕМУ ПЕРЕЕХАЛО. Константа менялась только новой сборкой: чтобы вернуть
 * видео, требовалась неделя ожидания в App Store. Теперь это тумблер `video` в
 * админке — выключил и включил обратно сколько угодно раз, без сборки.
 *
 * Читать так: `isFeatureOn('video')` из `@/lib/appConfig`. Значение по
 * умолчанию — выключено, потому что сервер видеоконференций не отвечает
 * (решение владельца от 18.08.2026).
 */
